import { Section, Eyebrow, Heading, P, PullQuote } from "../Chapter";
import { Reveal } from "../Reveal";

export const AInow = () => (
    <Section>
        <Eyebrow>IX. Now</Eyebrow>
        <Heading>And now the machine writes it</Heading>

        <P>The newest turn is stranger than the last one.</P>
        <P delay={0.05}>
            For the entire history of the letter — runner, steamer, telegraph, email — the
            technology moved the words. It never chose them. That line has now been crossed. A
            machine drafts the email, softens the tone, writes the condolence note, finds the
            phrasing you were reaching for.
        </P>
        <P delay={0.05}>
            It's genuinely useful. It helps people writing in a second language, people who freeze
            at a blank page, people with more to say than time to say it. This is not a complaint.
        </P>
        <P delay={0.05}>But it raises a question the postal service never had to answer:</P>

        <PullQuote>If the machine writes the letter, whose letter is it?</PullQuote>

        <P>
            There is no clean answer, and anyone offering one is selling something. Writing was
            always assisted — by dictionaries, by templates, by the friend who read it before you
            sent it. And by the scribe outside the post office, who wrote your words in his
            handwriting, in his phrasing, and everyone considered the letter yours.
        </P>
        <P delay={0.05}>
            Maybe that's the answer. Maybe we've done this before and simply forgot, because the
            last time it happened the assistant was a person.
        </P>

        <Reveal className="mx-auto mt-14 max-w-[52rem]">
            <div className="border-l-2 border-wax bg-surface px-7 py-8 md:px-10 md:py-10">
                <p className="font-mono text-sm leading-relaxed text-ink/80 md:text-[0.95rem]">
                    <span className="mb-3 block font-sans text-[0.68rem] tracking-[0.3em] uppercase text-wax">
                        Full disclosure
                    </span>
                    This website was built with AI. The layout, the code, the animation you scrolled
                    through a minute ago. A site about what happens when machines write for us, partly
                    written by one. That contradiction isn't hidden here. It may be the most honest
                    thing on the page.
                </p>
            </div>
        </Reveal>
    </Section>
);
